export const GET_CHEST_HUNTER = "GET_CHEST_HUNTER"
export const GET_CHEST_HUNTER_FAIL = "GET_CHEST_HUNTER_FAIL"
export const GET_CHEST_COUNT = "GET_CHEST_COUNT"
export const GET_CHEST_COUNT_FAIL = "GET_CHEST_COUNT_FAIL"
export const RESET_CHEST_COUNT = "RESET_CHEST_COUNT"
export const DECREASE_CHEST_COUNT = "DECREASE_CHEST_COUNT"

